import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://16dd6381da658c41a084a715cf5e09c5@o4509702162612224.ingest.us.sentry.io/4509702197805056",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});

window.Sentry = Sentry;
